import { render, staticRenderFns } from "./termsAndConditions.vue?vue&type=template&id=0fad6195&scoped=true&"
import script from "./termsAndConditions.vue?vue&type=script&lang=js&"
export * from "./termsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./termsAndConditions.vue?vue&type=style&index=0&id=0fad6195&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad6195",
  null
  
)

export default component.exports